export default {
  header: {
    algorithm: {
      complete: {
        en: "Complete",
        pt: "Completar",
      },
      convertNFDAtoFDA: {
        en: "Convert NDFA-λ → FDA",
        pt: "Conversão AFND-λ → AFD",
      },
      minimize: {
        en: "Minimize",
        pt: "Minimizar",
      },
      regexToAutomata: {
        en: "Regex to automata",
        pt: "Regex para autômato",
      },
      simulate: {
        en: "Simulate automata",
        pt: "Simular autômato",
      },
    },
    textBeforeAlgorithm: {
      en: "Algorithm applied",
      pt: "Algoritmo aplicado",
    },
  },
};
